// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bddc7045","320":"ce1731c3","788":"a79650bb"}[chunkId] + ".chunk.js";
};